module.exports = new __parcel__URL__("consulting.be2f78d8.png").toString();